import { Flex } from '@coolblue-development/freddy';
import styled from '@emotion/styled';
export const DownloadAppLinkContainer = styled(Flex) `
  height: 4rem;

  svg {
    height: 100%;
    width: 100%;
  }
`;
//# sourceMappingURL=DownloadAppLinkStyled.styled.js.map